/**
 * Build the sport jersey avatar URL from blob storage.
 * Mirrors apps/daily-reveal/src/utils/jerseyAvatar.ts.
 *
 * Sport-aware: MLB has one file per team, NFL cards use the position-cut jersey in
 * `nfl/jerseys-position/` (falling back to the plain team jersey for positions with no
 * artwork), and NBA non-IP marks live under `team-jerseys`. A contest can override the
 * folder via `style_config.teamAssetFolder`; when that override is `teams` (logos) the
 * sport's non-IP jersey path is still returned so player art never swaps to licensed
 * logos under League IP off.
 */
import { resolveJerseyStyleTeamUrl, type TeamAssetFolderId } from './teamAssetFolder';

/**
 * Jersey avatar URL for a team code, or an empty string when the sport or code is missing.
 *
 * @param teamCode - Team abbreviation (e.g. BAL, SEA)
 * @param sport - Sport code (e.g. 'MLB', 'NFL'). Defaults to 'MLB' for backward compatibility.
 * @param position - Roster position, used by the NFL position-cut jersey folder
 * @param contestFolder - Contest `style_config.teamAssetFolder` override, when set
 */
export function getJerseyAvatarUrl(
  teamCode: string | null | undefined,
  sport: string | null | undefined = 'MLB',
  position?: string | null,
  contestFolder: TeamAssetFolderId | null = null
): string {
  return resolveJerseyStyleTeamUrl(teamCode, sport, position, contestFolder);
}
